import { call, put, takeEvery } from "redux-saga/effects";
import { keHoachMonApi } from "../../../api/ke-hoach/keHoachMonApi";
import { keHoachMonChiTietApi } from "../../../api/ke-hoach/keHoachMonChiTietApi";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IKeHoachMonChiTietSaveRequest } from "../../../model/request/ke-hoach/IKeHoachMonChiTietSaveRequest";
import { IKeHoachMonSelectViewRequest } from "../../../model/request/ke-hoach/IKeHoachMonSelectViewRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IKeHoachMonViewModel } from "../../../model/respone/ke-hoach/IKeHoachMonViewModel";
import { eKeHoachMonNVActionIds, IKeHoachMonNVActionTypes } from "../../action-types/ke-hoach/IKeHoachMonNVActions";
import { rootActions } from "../../actions/rootActions";
import { keHoachPhamViApi } from "../../../api/ke-hoach/keHoachPhamViApi";
import { IKeHoachGhepLopRequest } from "../../../model/request/ke-hoach/IKeHoachGhepLopRequest";

export function* keHoachMonNvSaga(): any {
    yield takeEvery(eKeHoachMonNVActionIds.LOAD_START, loadKeHoachLopWorker);
    yield takeEvery(eKeHoachMonNVActionIds.UPDATE_KHM_START, updateKHMWorker);
    yield takeEvery(eKeHoachMonNVActionIds.SAVE_CHITIET_START, saveChiTietWorker);
    yield takeEvery(eKeHoachMonNVActionIds.DELETE_CHITIET_START, deleteChiTietWorker);
    yield takeEvery(eKeHoachMonNVActionIds.UPDATE_GHEP_LOP_START, updateKeHoachMonGhepLopWorker);

}


function* loadKeHoachLopWorker(action: IKeHoachMonNVActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonApi.SelectView, action.payload as IKeHoachMonSelectViewRequest);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachMonNV.LOAD_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.keHoach.keHoachMonNV.LOAD_ERRR(res.message ?? "Có lỗi")
        );
    }
}

function* updateKHMWorker(action: IKeHoachMonNVActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonApi.UpdateMonHoc, action.payload as IKeHoachMonViewModel[]);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachMonNV.UPDATE_KHM_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.keHoach.keHoachMonNV.UPDATE_KHM_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* saveChiTietWorker(action: IKeHoachMonNVActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonChiTietApi.Saves, action.payload as IKeHoachMonChiTietSaveRequest);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachMonNV.SAVE_CHITIET_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.keHoach.keHoachMonNV.SAVE_CHITIET_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* deleteChiTietWorker(action: IKeHoachMonNVActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonChiTietApi.Deletes, action.payload as IIdsRequest);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachMonNV.DELETE_CHITIET_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.keHoach.keHoachMonNV.DELETE_CHITIET_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* updateKeHoachMonGhepLopWorker(action: IKeHoachMonNVActionTypes): any {
    const res: IBaseRespone = yield call(keHoachPhamViApi.Saves, action.payload as IKeHoachGhepLopRequest);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachMonNV.UPDATE_KHM_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.keHoach.keHoachMonNV.UPDATE_KHM_ERROR(res.message ?? "Có lỗi")
        );
    }
}
